import { ErrorHandler, Service, inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { serializeError } from "serialize-error";
import { environment } from "../../../environments/environment";


@Service()
export class ErrorReporter implements ErrorHandler {
  private readonly authService = inject(AuthService);


  handleError(error: unknown) {
    console.log('<==================== Error from global error handler ====================>');
    console.error(error);
    console.log('<=============================== End =====================================>');
    if (environment.name !== 'local') {
      this.logException(error);
    }
  }


  logException(error: unknown): void {

    const payload = [{
      type: 'application',
      error: serializeError(error),
      user: this.authService.email(),
      localtime: new Date().toLocaleTimeString('pl-PL'),
      env: environment.name,
      version: environment.version,
      location: window.location,
      url: window.location.href,
      user_agent: window.navigator.userAgent,
    }];

    navigator.sendBeacon(`${environment.urls.reportingApi}default`, JSON.stringify(payload));
  }

  log(log: string): void {
    const blob = new Blob([JSON.stringify(log)], { type: 'application/json' });
    navigator.sendBeacon(`${environment.urls.reportingApi}default`, blob);
  }

}
